import type { Text } from 'mdast';

import type { JsxCommentTokenElement, Serializer } from '@ui/MarkdownEditor/types';

export const serialize: Serializer<JsxCommentTokenElement, Text> = node => {
  return { type: 'text', value: node.edge === 'start' ? '{/*' : '*/}' };
};
